import gql from 'graphql-tag'

export const ProjectSelectorOption_project = gql`
  fragment ProjectSelectorOption_project on VIProjects {
    id
    name
  }
`
